const initialState = {
    showBusinessBtn: false,
    isOpenBusinessForm: false,
    franchise: {
        showBusinessBtn: false,
        isOpenBusinessForm: false
    }
}

const dayCareReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'HANDLE_ADD_BUSINESS_CUSTOMER_FORM':
            if (action.value.type === "showBtn") {
                return { ...state, showBusinessBtn: action.value.value }
            } else if (action.value.type === "openForm") {
                return { ...state, isOpenBusinessForm: action.value.value }
            }
            break
        case 'HANDLE_ADD_BUSINESS_CUSTOMER_FORM_FRANCHISE':
            const { type, value } = action.value
            if (type === "showBtn") {
                return { ...state, franchise: { ...state.franchise, showBusinessBtn: value } }
            } else if (type === "openForm") {
                return { ...state, franchise: { ...state.franchise, isOpenBusinessForm: value } }
            }

            break
        default:
            return state
    }
}

export default dayCareReducer